import Vue from "vue";
import App from "./App";
import store from "./store";
import i18n from "./i18n";
import router from "./router";

import VueResource from "vue-resource";
import "vue2-toast/lib/toast.css";
import Toast from "vue2-toast";
import VeeValidate from "vee-validate";
import Vuetify from 'vuetify';
import EventsManager from "./assets/EventsManager";
import EventManagerMenu from "./assets/EventManagerMenu";
import ('../node_modules/vuetify/dist/vuetify.min.css');

Vue.config.productionTip = false;
Vue.prototype.$moment = require('moment');
Vue.prototype.$eventsManager = new EventsManager(store)
Vue.prototype.$eventManagerMenu = new EventManagerMenu()

Vue.use(VeeValidate);
Vue.use(VueResource);
Vue.use(Toast);
Vue.use(Vuetify);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js